document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('[data-aa-sticky-atc]');
  const primary = document.querySelector('.product-form__submit');
  if (!sticky || !primary) return;

  const stickyButton = sticky.querySelector('[data-aa-sticky-button]');
  const observer = new IntersectionObserver(([entry]) => {
    sticky.classList.toggle('is-visible', !entry.isIntersecting);
  }, { threshold: 0 });

  observer.observe(primary);
  stickyButton?.addEventListener('click', () => primary.click());
});
